module.exports = __webpack_public_path__ + "static/media/Chapter9.df16a697.pdf";